export default "__VITE_ASSET__h7L7uWzZ__"